import Swiper from 'swiper'
import { Navigation, Pagination, EffectFade } from 'swiper/modules';

class Slider {
  constructor() {
    this.slider = document.querySelector('.js-swiper');

    if (!this.slider) {
      return;
    }

    this.initializeSlider();
  }

  initializeSlider() {
    const slider = new Swiper(this.slider, {
      modules: [Navigation, Pagination, EffectFade],
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      speed: 1000,
      autoHeight: true,
      height: 400,
      effect: 'fade',
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }
}

export default Slider;
